import Image from '@/components/atoms/image/image';
import Typography from '@/components/atoms/typography/typography';
import Link from '@/components/utilities/link/link';
import BrandTeasersLogo from '../brand-teasers-logo/brand-teasers-logo';
import styles from './brand-teasers-item.module.scss';

export interface BrandTeasersItemProps {
  /** The brand logo to display */
  brand?: Content.Components['BrandTeaser']['brand'];
  /** The headline to display */
  headline: Content.Components['BrandTeaser']['headline'];
  /** The image to display */
  image: Content.Components['BrandTeaser']['image'];
  /** The link for the card */
  link: Content.Components['BrandTeaser']['link'];
}

const BrandTeasersItem = ({
  brand,
  headline,
  image,
  link,
}: BrandTeasersItemProps) => {
  const renderContent = () => (
    <div className={styles.container}>
      <BrandTeasersLogo
        brand={brand as Content.Properties.Brand}
        className={styles.logo}
      />

      <div className={styles.mask}>
        <Image
          alt={image.altText}
          className={styles.image}
          fill
          focalPoint={image.focalPoint}
          height={202}
          src={image.url}
          srcSet={{
            laptop: {
              height: 426,
              width: 426,
            },
            tablet: {
              height: 343,
              width: 343,
            },
          }}
          unoptimized
          width={202}
        />

        <Typography className={styles.headline} tagStyle="headingSmall">
          {headline}
        </Typography>
      </div>
    </div>
  );

  if (!link) {
    return (
      <div className={styles.component} data-brand={brand}>
        {renderContent()}
      </div>
    );
  }

  return (
    <Link
      aria-label={link.text}
      className={styles.component}
      data-brand={brand}
      target={link.target}
      url={link.url}
    >
      {renderContent()}
    </Link>
  );
};

BrandTeasersItem.displayName = 'BrandTeasersItem';

export default BrandTeasersItem;
